import { ROLES } from './Role';

export const BILLING_ALLOWED_ROLES: Array<keyof typeof ROLES> = [
  ROLES.ADMIN,
  ROLES.SUPER_ADMIN,
  ROLES.DOMAIN_OWNER,
];

export const BILLING_SEAT_SYNC_NOTE =
  'All workspace users share the same plan and must each have a paid seat \u2013 mixed plans are not supported. Hana automatically matches your active users to the number of seats purchased. Managing seats outside this dashboard can reduce your seat count and block users, so make changes here.';

export const BILLING_PAGE_DESCRIPTION =
  'Manage your subscription plan, seat assignments and invoices.';

export const PRO_PLAN_BENEFITS_NOTE =
  'PRO plan users benefit from more robust algorithms, dedicated support, and a more stable and scalable product as operations for them are prioritized.';

export const PRO_PLAN_INTELLIGENCE_NOTE =
  'Hana has PhD level intelligence on the PRO plan due to advanced industry-leading models.';
